/** Brand glyphs `SocialIcon` (components/icons.tsx) can draw. */
export type SocialIconName =
  'facebook' | 'x' | 'youtube' | 'instagram' | 'tiktok'

/** Social profiles, in footer order. TikTok is separate: shown only on /take-action. */
export const SOCIAL_LINKS: {
  name: SocialIconName
  label: string
  href: string
}[] = [
  {
    name: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/directactioneverywhere',
  },
  { name: 'x', label: 'X (Twitter)', href: 'https://twitter.com/dxeverywhere' },
  {
    name: 'youtube',
    label: 'YouTube',
    href: 'https://www.youtube.com/channel/UC_mn5Mn952NC1WfwnOLWjew',
  },
  {
    name: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/directactioneverywhere/',
  },
]

export const TIKTOK_LINK: {
  name: SocialIconName
  label: string
  href: string
} = {
  name: 'tiktok',
  label: 'TikTok',
  href: 'https://www.tiktok.com/@directactioneverywheresf',
}

/** The 501(c)(3) that takes donations. */
export const FRIENDS_OF_DXE = {
  legalName: 'Friends of DxE',
  ein: '46-4318107',
  /** Mailing address, one entry per line. */
  addressLines: ['PMB 328', '2425 Channing Way, Ste. B', 'Berkeley, CA 94704'],
  email: 'donate@friendsofdxe.com',
  phone: '669-666-2159',
}

export const ANNUAL_REPORT_URL =
  'https://media.directactioneverywhere.com/media/7a6342b968a5ed98/DxE-2025-Annual-Report.pdf'

export const FINANCIAL_REPORT_URL =
  'https://media.directactioneverywhere.com/media/2c5c7119154f7a46/Financial-Transparency-2025.pdf'

/** Double the Donation plugin (same public key as the Webflow embed). */
export const DTD = {
  key: 'O86SHXIIhMJkuoIA',
  scriptUrl: 'https://doublethedonation.com/api/js/ddplugin.js',
}
